/* @flow */
import * as React from "react";
import type { Element, Component } from "react";
import { iconFromAPIName } from "nx-components/Icons";
import DeviceThermostatIcon from "nexia_mobile/components/DeviceThermostatIcon";
import type { Icon, IconList } from "nexia_mobile/api/types";

type ParsedIconWithoutElement = {
  key: string,
  name: string,
  class:
    | Class<Component<any, any>>
    | ((Object, ?Object) => Element<any> | null),
  modifiers: Array<string>,
};

type ParsedIcon = ParsedIconWithoutElement & {
  element: Element<any>,
};

function parseValues(icons: IconList): Array<ParsedIconWithoutElement> {
  // $FlowFixMe the type for _.flatten is wrong in the library we're using.
  let values: Array<Icon> = _.flatten([icons]);

  // convert all icons to a common pattern {name, class, modifiers, key}
  return values.map((value) => {
    let icon = {};
    if (value != null && typeof value == "object") {
      icon.name = value.name;
      icon.class = iconFromAPIName(icon.name);
      icon.modifiers = value.modifiers || [];
      icon.key = `${icon.name} ${icon.modifiers.join(" ")}`;
    } else {
      icon.name = value;
      icon.class = iconFromAPIName(value);
      icon.modifiers = [];
      icon.key = value;
    }
    return icon;
  });
}

type ParseOptions = {
  showThermostatTemperatureModifier: boolean,
  ignoreModifiers?: boolean,
};

function createElementsFromValues(
  values: Array<ParsedIconWithoutElement>,
  options: ParseOptions
): Array<ParsedIcon> {
  return values.map((icon) => {
    let element;
    if (icon.name === "thermostat") {
      element = (
        <DeviceThermostatIcon
          value={icon}
          includeTemperature={options.showThermostatTemperatureModifier}
        />
      );
    } else {
      let IconClass = icon.class;
      element = (
        <IconClass
          {...(options.ignoreModifiers ? null : { modifiers: icon.modifiers })}
        />
      );
    }
    return {
      ...icon,
      element,
    };
  });
}

export default function parseIconsFromServer(
  icons: IconList,
  options: ParseOptions = { showThermostatTemperatureModifier: false }
): Array<ParsedIcon> {
  let values = parseValues(icons);
  // filter in case an icon fails to match a class in iconFromAPIName
  values = values.filter((value) => Boolean(value.class));
  return createElementsFromValues(values, options);
}



// WEBPACK FOOTER //
// ./src/parseIconsFromServer.jsx